// import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
// import { AgGridReact } from "ag-grid-react"
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-material.css';

// const ProgramManagerMasterGrid = (props) => {

//     const gridRef = useRef()
//     const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
//     const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

//     const columnDefs = [
//         {
//             headerName: 'Id',
//             field: 'Sr_No',
//             width:100
//         },
//         {
//             headerName: 'Program Manager',
//             field: 'sProgramManager',
//             flex: 1
//         },
//     ]

//     return (
//         <div>
//             <div style={{
//                 height: "75vh",
//             }}>
//                 <div style={{ height: "100%", boxSizing: "border-box" }}>
//                     <div style={gridStyle} className="ag-theme-material" >
//                         <AgGridReact ref={gridRef}
//                             rowData={props.tableData || []}
//                             columnDefs={columnDefs}
//                             pagination={true}
//                             paginationPageSize={15}
//                         >
//                         </AgGridReact>
//                     </div>
//                 </div>
//             </div>

//         </div>
//     )
// }

// export default ProgramManagerMasterGrid



// NEW WORKING CODE WITH CUSTOM SERIAL NUMBER AND SORTE DATA
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

const ProgramManagerMasterGrid = (props) => {

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const columnDefs = [
        {
            headerName: 'Sr No.',
            valueGetter: (params) => params.node.rowIndex + 1, // Calculate row index as serial number
            width: 100,
        },
        {
            headerName: 'Program Manager',
            field: 'sProgramManager',
            flex: 1
        },
    ]

    return (
        <div>
            <div style={{
                height: "75vh",
            }}>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material" >
                        <AgGridReact ref={gridRef}
                            rowData={props.tableData || []}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={15}
                        >
                        </AgGridReact>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ProgramManagerMasterGrid